import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import * as equipsnSyncActions from 'redux/modules/equipsnSync';

import { Button, ButtonToolbar, InputGroup, FormControl, DropdownButton, MenuItem, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const styles = {
  container: { padding: '20px' },
  statsRow: { display: 'flex', flexWrap: 'wrap', gap: '15px', marginBottom: '20px' },
  statCard: {
    flex: '1 1 200px',
    padding: '15px',
    borderRadius: '5px',
    background: '#f5f5f5',
    border: '1px solid #ddd'
  },
  statValue: { fontSize: '24px', fontWeight: 'bold', color: '#333' },
  statLabel: { fontSize: '12px', color: '#666', textTransform: 'uppercase' },
  filtersRow: { display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '15px', alignItems: 'center' },
  table: { width: '100%', fontSize: '12px' },
  th: { padding: '6px', background: '#f0f0f0', textAlign: 'left', borderBottom: '2px solid #ccc' },
  td: { padding: '6px', borderBottom: '1px solid #eee' },
  badge: { padding: '2px 6px', borderRadius: '3px', fontSize: '11px', color: '#fff' },
  badgeGreen: { background: '#5cb85c' },
  badgeRed: { background: '#d9534f' },
  badgeOrange: { background: '#f0ad4e' },
  badgeBlue: { background: '#337ab7' },
  badgeGray: { background: '#999' },
  manualInput: { width: '180px', fontSize: '11px' },
  pagination: { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', marginTop: '15px' },
  candidateCard: {
    border: '1px solid #ddd',
    borderRadius: '5px',
    padding: '12px',
    marginBottom: '10px',
    background: '#fafafa'
  },
  candidateCardMatch: {
    border: '2px solid #5cb85c',
    background: '#f0fff0'
  },
  candidateHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' },
  candidateObjectId: { fontWeight: 'bold', fontSize: '14px' },
  candidateMeta: { fontSize: '11px', color: '#666' },
  eventRow: { fontSize: '11px', padding: '2px 0', fontFamily: 'monospace' }
};

@translate(['common'])
@connect(
  state => ({
    data: state.equipsnSync.data,
    total: state.equipsnSync.total,
    loading: state.equipsnSync.loading,
    error: state.equipsnSync.error,
    stats: state.equipsnSync.stats,
    statsLoading: state.equipsnSync.statsLoading,
    resyncLoading: state.equipsnSync.resyncLoading,
    resyncResult: state.equipsnSync.resyncResult,
    resyncError: state.equipsnSync.resyncError,
    updateLoading: state.equipsnSync.updateLoading,
    updateError: state.equipsnSync.updateError,
    resolveLoading: state.equipsnSync.resolveLoading,
    resolveResult: state.equipsnSync.resolveResult,
    resolveError: state.equipsnSync.resolveError,
    historyLoading: state.equipsnSync.historyLoading,
    historyRows: state.equipsnSync.historyRows,
    historyError: state.equipsnSync.historyError,
    resyncOneLoading: state.equipsnSync.resyncOneLoading,
    resyncOneError: state.equipsnSync.resyncOneError,
    exportLoading: state.equipsnSync.exportLoading,
    cleanOrphansLoading: state.equipsnSync.cleanOrphansLoading,
    cleanOrphansResult: state.equipsnSync.cleanOrphansResult,
    authorizationLoading: state.equipsnSync.authorizationLoading,
    authorizationError: state.equipsnSync.authorizationError,
    authorizationsLoading: state.equipsnSync.authorizationsLoading,
    authorizationsError: state.equipsnSync.authorizationsError,
    authorizations: state.equipsnSync.authorizations,
    authorizationsTotal: state.equipsnSync.authorizationsTotal,
    clientKeyLoading: state.equipsnSync.clientKeyLoading,
    clientKeyError: state.equipsnSync.clientKeyError,
    clientKeyResult: state.equipsnSync.clientKeyResult,
    clientKeysLoading: state.equipsnSync.clientKeysLoading,
    clientKeysError: state.equipsnSync.clientKeysError,
    clientKeys: state.equipsnSync.clientKeys,
    exportAuthLoading: state.equipsnSync.exportAuthLoading,
    exportAuthError: state.equipsnSync.exportAuthError,
    fetchAsmKeysLoading: state.equipsnSync.fetchAsmKeysLoading,
    fetchAsmKeysError: state.equipsnSync.fetchAsmKeysError,
    fetchAsmKeysResult: state.equipsnSync.fetchAsmKeysResult,
    pushScopeLoading: state.equipsnSync.pushScopeLoading,
    pushScopeError: state.equipsnSync.pushScopeError
  }),
  { ...equipsnSyncActions }
)
export default class EquipsnSync extends Component {

  state = {
    page: 1,
    perPage: 50,
    search: '',
    filterAccount: 'all',
    filterResolved: 'all',
    editingId: null,
    editingValue: '',
    resolveModal: { open: false, row: null },
    historyModal: { open: false, row: null },
    showAuthorizations: false,
    authorizationsPage: 1,
    lastScopeSync: null,
    showClientKeys: false,
    newKeyClientId: '',
    newKeyType: 'session',
    newKeyValue: ''
  };

  componentDidMount() {
    this.props.load(this._buildParams());
    this.props.loadStats();
  }

  _buildParams() {
    return {
      page: this.state.page,
      perPage: this.state.perPage,
      search: this.state.search,
      filterAccount: this.state.filterAccount,
      filterResolved: this.state.filterResolved
    };
  }

  _reload() {
    this.props.load(this._buildParams());
    this.props.loadStats();
    if (this.state.showAuthorizations) this.loadAuthorizations(this.state.authorizationsPage);
  }

  loadAuthorizations = (page) => {
    this.setState({ authorizationsPage: page });
    this.props.loadTestLiftAuthorizations({ page }).catch(() => {});
  }

  reportScopeSync = (result) => {
    if (result && result.scopeSync) this.setState({ lastScopeSync: result.scopeSync });
  }

  handleValidateTestLift = (row) => {
    if (!window.confirm(this.props.t('equipsnSync.confirm_validate_testlift', {
      account: row.account, clientId: row.client_id, productId: row.product_id, equipsn: row.resolved_object_id
    }))) return Promise.resolve();
    return this.props.setTestLiftAuthorization({
      active: true, mappingId: row.id, expectedEquipsn: row.resolved_object_id,
      expectedVersion: Number(row.testlift_version || 0)
    }).then((result) => { this.reportScopeSync(result); this._reload(); }).catch(() => {});
  }

  handleRevokeTestLift = (authorization) => {
    if (!window.confirm(this.props.t('equipsnSync.confirm_revoke_testlift', {
      account: authorization.account || authorization.client_id, equipsn: authorization.equipsn
    }))) return Promise.resolve();
    return this.props.setTestLiftAuthorization({
      active: false, authorizationId: authorization.id, expectedVersion: Number(authorization.version)
    }).then((result) => { this.reportScopeSync(result); this._reload(); }).catch(() => {});
  }

  loadClientKeys = () => {
    this.props.loadClientKeys().catch(() => {});
  }

  handleNewKeyClientIdChange = (e) => {
    this.setState({ newKeyClientId: e.target.value });
  }

  handleNewKeyValueChange = (e) => {
    this.setState({ newKeyValue: e.target.value });
  }

  handleNewKeyTypeChange = (e) => {
    this.setState({ newKeyType: e.target.value });
  }

  handleSetClientKey = (e) => {
    e.preventDefault();
    const { newKeyClientId, newKeyType, newKeyValue } = this.state;
    const clientId = parseInt(newKeyClientId, 10);
    if (!clientId || !newKeyValue) return Promise.resolve();
    if (!window.confirm(this.props.t('equipsnSync.confirm_set_client_key', { clientId, keyType: this.props.t('equipsnSync.key_type_' + newKeyType) }))) return Promise.resolve();
    return this.props.setClientKey(clientId, newKeyType, newKeyValue).then(() => {
      // La clé saisie n'est jamais réaffichée : on vide le champ immédiatement.
      this.setState({ newKeyClientId: '', newKeyValue: '' });
      this.loadClientKeys();
    }).catch(() => {
      this.setState({ newKeyValue: '' });
    });
  }

  handleRevokeClientKey = (clientId, keyType) => {
    if (!window.confirm(this.props.t('equipsnSync.confirm_revoke_client_key', { clientId, keyType: this.props.t('equipsnSync.key_type_' + keyType) }))) return;
    this.props.revokeClientKey(clientId, keyType).then(() => this.loadClientKeys()).catch(() => {});
  }

  handleFetchAsmKeys = () => {
    const clientId = parseInt(this.state.newKeyClientId, 10);
    if (!clientId) return Promise.resolve();
    if (!window.confirm(this.props.t('equipsnSync.confirm_fetch_asm_keys', { clientId }))) return Promise.resolve();
    return this.props.fetchAsmKeys(clientId).then(() => this.loadClientKeys()).catch(() => {});
  }

  handlePushScopeNow = () => {
    const clientId = parseInt(this.state.newKeyClientId, 10);
    if (!clientId) return Promise.resolve();
    return this.props.pushScopeNow(clientId).then((result) => this.reportScopeSync({ scopeSync: result })).catch(() => {});
  }

  handleExportTestLiftAuthorizations = () => {
    this.props.exportTestLiftAuthorizations().then((result) => {
      var csv = result && result.csv;
      var filename = (result && result.filename) || 'testlift_authorizations.csv';
      if (!csv) return;
      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }).catch(() => {});
  }

  renderClientKeys() {
    const { t, clientKeys, clientKeysLoading, clientKeysError, clientKeyLoading, clientKeyError, clientKeyResult } = this.props;
    const { newKeyClientId, newKeyType, newKeyValue } = this.state;
    return (
      <section className="panel panel-default">
        <div className="panel-heading">{t('equipsnSync.client_keys_title')}</div>
        <div className="panel-body">
          <p className="text-muted">{t('equipsnSync.client_keys_help')}</p>

          <form onSubmit={this.handleSetClientKey} style={{ marginBottom: '15px' }}>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
              <div>
                <label>{t('equipsnSync.col_client_id')}</label>
                <FormControl
                  type="number"
                  style={{ width: '120px' }}
                  value={newKeyClientId}
                  onChange={this.handleNewKeyClientIdChange}
                  placeholder="7"
                />
              </div>
              <div>
                <label>{t('equipsnSync.client_key_type')}</label>
                <FormControl componentClass="select" style={{ width: '160px' }} value={newKeyType} onChange={this.handleNewKeyTypeChange}>
                  <option value="session">{t('equipsnSync.key_type_session')}</option>
                  <option value="scope">{t('equipsnSync.key_type_scope')}</option>
                </FormControl>
              </div>
              <div style={{ flex: '1 1 300px' }}>
                <label>{t('equipsnSync.client_key_value')}</label>
                <FormControl
                  type="password"
                  autoComplete="new-password"
                  value={newKeyValue}
                  onChange={this.handleNewKeyValueChange}
                  placeholder={t('equipsnSync.client_key_placeholder')}
                />
              </div>
              <Button type="submit" bsStyle="success" disabled={clientKeyLoading || !newKeyClientId || !newKeyValue}>
                {t('equipsnSync.save_client_key')}
              </Button>
            </div>
          </form>

          <div style={{ marginBottom: '15px' }}>
            <Button bsSize="sm" bsStyle="primary" onClick={this.handleFetchAsmKeys} disabled={this.props.fetchAsmKeysLoading || !newKeyClientId}>
              <i className={this.props.fetchAsmKeysLoading ? 'fa fa-refresh fa-spin' : 'fa fa-cloud-download'} /> {t('equipsnSync.fetch_asm_keys')}
            </Button>
            &nbsp;
            <Button bsSize="sm" onClick={this.handlePushScopeNow} disabled={this.props.pushScopeLoading || !newKeyClientId}>
              <i className={this.props.pushScopeLoading ? 'fa fa-refresh fa-spin' : 'fa fa-upload'} /> {t('equipsnSync.push_scope_now')}
            </Button>
            <p className="text-muted" style={{ fontSize: '12px', marginTop: '4px' }}>{t('equipsnSync.fetch_asm_keys_help')}</p>
          </div>

          {this.props.fetchAsmKeysError && <div className="alert alert-danger" role="alert">{this.props.fetchAsmKeysError.message || t('main.connection_error')}</div>}
          {this.props.fetchAsmKeysResult && (
            <div className="alert alert-success">
              {t('equipsnSync.fetch_asm_keys_done', {
                sessionAction: t('equipsnSync.client_key_action_' + this.props.fetchAsmKeysResult.session.action),
                scopeAction: t('equipsnSync.client_key_action_' + this.props.fetchAsmKeysResult.scope.action)
              })}
            </div>
          )}
          {this.props.pushScopeError && <div className="alert alert-danger" role="alert">{this.props.pushScopeError.message || t('main.connection_error')}</div>}

          {clientKeyError && <div className="alert alert-danger" role="alert">{clientKeyError.message || t('main.connection_error')}</div>}
          {clientKeyResult && (
            <div className="alert alert-success">
              {t('equipsnSync.client_key_saved', { version: clientKeyResult.version, action: t('equipsnSync.client_key_action_' + clientKeyResult.action) })}
            </div>
          )}

          <Button bsSize="sm" onClick={this.loadClientKeys} disabled={clientKeysLoading}>
            <i className={clientKeysLoading ? 'fa fa-refresh fa-spin' : 'fa fa-refresh'} /> {t('equipsnSync.reload')}
          </Button>
          &nbsp;
          <Button bsSize="sm" onClick={this.handleExportTestLiftAuthorizations} disabled={this.props.exportAuthLoading}>
            <i className={this.props.exportAuthLoading ? 'fa fa-refresh fa-spin' : 'fa fa-download'} /> {t('equipsnSync.export_testlift_authorizations')}
          </Button>

          {clientKeysError && <div className="alert alert-danger" role="alert">{clientKeysError.message || t('main.connection_error')}</div>}
          {this.props.exportAuthError && <div className="alert alert-danger" role="alert">{this.props.exportAuthError.message || t('main.connection_error')}</div>}

          <div className="table-responsive" style={{ marginTop: '10px' }}>
            <table style={styles.table}>
              <thead><tr>
                <th style={styles.th}>{t('equipsnSync.col_client_id')}</th>
                <th style={styles.th}>{t('equipsnSync.col_account')}</th>
                <th style={styles.th}>{t('equipsnSync.client_key_type')}</th>
                <th style={styles.th}>{t('equipsnSync.client_key_version')}</th>
                <th style={styles.th}>{t('equipsnSync.testlift_validated_by')}</th>
                <th style={styles.th}>{t('equipsnSync.col_actions')}</th>
              </tr></thead>
              <tbody>
                {clientKeys.map(k => <tr key={k.client_id + '-' + k.key_type}>
                  <td style={styles.td}>{k.client_id}</td>
                  <td style={styles.td}>{k.account}</td>
                  <td style={styles.td}>{t('equipsnSync.key_type_' + k.key_type)}</td>
                  <td style={styles.td}>{k.key_version}</td>
                  <td style={styles.td}>{k.created_by_name} — {k.created_at}</td>
                  <td style={styles.td}>
                    <Button bsStyle="danger" bsSize="xs" disabled={clientKeyLoading} onClick={() => this.handleRevokeClientKey(k.client_id, k.key_type)}>
                      {t('equipsnSync.revoke_client_key')}
                    </Button>
                  </td>
                </tr>)}
                {!clientKeys.length && <tr><td colSpan="6">{t('equipsnSync.no_data')}</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    );
  }

  renderAuthorizations() {
    const { t, authorizations, authorizationsLoading, authorizationsError, authorizationsTotal, authorizationLoading } = this.props;
    const page = this.state.authorizationsPage;
    return (
      <section className="panel panel-default">
        <div className="panel-heading">{t('equipsnSync.testlift_authorizations')}</div>
        <div className="panel-body">
          <p>{t('equipsnSync.testlift_authorizations_help')}</p>
          {authorizationsError && <div className="alert alert-danger" role="alert">{authorizationsError.message || t('main.connection_error')}</div>}
          {authorizationsLoading ? <p>{t('equipsnSync.loading')}</p> : (
            <div className="table-responsive">
              <table style={styles.table}>
                <thead><tr>
                  <th style={styles.th}>{t('equipsnSync.col_account')}</th>
                  <th style={styles.th}>{t('equipsnSync.col_client_id')}</th>
                  <th style={styles.th}>{t('equipsnSync.col_product_id')}</th>
                  <th style={styles.th}>{t('equipsnSync.col_equipsn')}</th>
                  <th style={styles.th}>{t('equipsnSync.col_status')}</th>
                  <th style={styles.th}>{t('equipsnSync.testlift_validated_by')}</th>
                  <th style={styles.th}>{t('equipsnSync.col_actions')}</th>
                </tr></thead>
                <tbody>
                  {authorizations.map(a => <tr key={a.id}>
                    <td style={styles.td}>{a.account || '—'}</td>
                    <td style={styles.td}>{a.client_id}</td>
                    <td style={styles.td}>{a.product_id}</td>
                    <td style={styles.td}>{a.equipsn}</td>
                    <td style={styles.td}>{t('equipsnSync.testlift_' + (Number(a.active) === 1 ? 'validated' : 'revoked'))}</td>
                    <td style={styles.td}>{a.validated_by_name} — {a.validated_at}
                      {a.revoked_at && <div>{a.revoked_by_name} — {a.revoked_at}</div>}
                    </td>
                    <td style={styles.td}>{Number(a.active) === 1 && <Button bsStyle="danger" bsSize="xs" disabled={authorizationLoading} onClick={() => this.handleRevokeTestLift(a)}>{t('equipsnSync.revoke_testlift')}</Button>}</td>
                  </tr>)}
                  {!authorizations.length && <tr><td colSpan="7">{t('equipsnSync.no_data')}</td></tr>}
                </tbody>
              </table>
            </div>
          )}
          <div style={styles.pagination}>
            <Button bsSize="sm" disabled={authorizationsLoading || page <= 1} onClick={() => this.loadAuthorizations(page - 1)}>{t('pagination.previous')}</Button>
            <span>{page} / {Math.max(1, Math.ceil(authorizationsTotal / 50))}</span>
            <Button bsSize="sm" disabled={authorizationsLoading || page * 50 >= authorizationsTotal} onClick={() => this.loadAuthorizations(page + 1)}>{t('pagination.next')}</Button>
          </div>
        </div>
      </section>
    );
  }

  handleSearchChange = (e) => {
    this.setState({ search: e.target.value, page: 1 });
  }

  handleSearchSubmit = (e) => {
    e.preventDefault();
    this.setState({ page: 1 }, () => this.props.load(this._buildParams()));
  }

  handleFilterAccount = (e) => {
    this.setState({ filterAccount: e.target.value, page: 1 }, () => this.props.load(this._buildParams()));
  }

  handleFilterResolved = (key) => {
    this.setState({ filterResolved: key, page: 1 }, () => this.props.load(this._buildParams()));
  }

  handlePageChange = (newPage) => {
    if (newPage < 1) return;
    this.setState({ page: newPage }, () => this.props.load(this._buildParams()));
  }

  handleResync = () => {
    if (!confirm(this.props.t('equipsnSync.confirm_resync'))) return;
    this.props.resync().then(() => {
      setTimeout(() => this._reload(), 500);
    });
  }

  handleEditStart = (id, currentValue) => {
    this.setState({ editingId: id, editingValue: currentValue || '' });
  }

  handleEditChange = (e) => {
    this.setState({ editingValue: e.target.value });
  }

  handleEditSave = (id) => {
    this.props.updateManual(id, this.state.editingValue).then(() => {
      this.setState({ editingId: null, editingValue: '' });
      this.props.load(this._buildParams());
    });
  }

  handleEditCancel = () => {
    this.setState({ editingId: null, editingValue: '' });
  }

  handleResolveOpen = (row) => {
    this.setState({ resolveModal: { open: true, row: row } });
    this.props.resolve(row.serial, row.account);
  }

  handleResolveClose = () => {
    this.setState({ resolveModal: { open: false, row: null } });
  }

  handleResolvePick = (objectId) => {
    var row = this.state.resolveModal.row;
    if (!row) return;
    this.props.updateManual(row.id, objectId).then(() => {
      this.setState({ resolveModal: { open: false, row: null } });
      this.props.load(this._buildParams());
    });
  }

  handleHistoryOpen = (row) => {
    this.setState({ historyModal: { open: true, row: row } });
    this.props.loadHistory(row.id);
  }

  handleHistoryClose = () => {
    this.setState({ historyModal: { open: false, row: null } });
  }

  handleResyncOne = (row) => {
    this.props.resyncOne(row.id).then(() => {
      this.props.load(this._buildParams());
    });
  }

  handleExportCsv = () => {
    this.props.exportCsv().then((result) => {
      var csv = result && result.csv;
      var filename = (result && result.filename) || 'equipsn_sync.csv';
      if (!csv) return;
      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    });
  }

  handleCleanOrphan = (row) => {
    if (!confirm(this.props.t('equipsnSync.confirm_clean_one'))) return;
    this.props.cleanOrphans(row.id).then(() => {
      this.props.load(this._buildParams());
      this.props.loadStats();
    });
  }

  handleCleanAllOrphans = () => {
    if (!confirm(this.props.t('equipsnSync.confirm_clean_all'))) return;
    this.props.cleanOrphans(null).then(() => {
      this.props.load(this._buildParams());
      this.props.loadStats();
    });
  }

  render() {
    const { t, data, total, loading, error, stats, resyncLoading, resyncResult, resyncError, updateLoading,
      exportLoading, resyncOneLoading, cleanOrphansLoading, cleanOrphansResult } = this.props;
    const { page, perPage, search, filterAccount, filterResolved, editingId, editingValue } = this.state;

    const totalPages = Math.ceil(total / perPage);

    // Liste des accounts depuis les stats
    var accountOptions = [];
    if (stats && stats.by_account) {
      accountOptions = stats.by_account.map(a => a.account);
    }

    return (
      <div className="container" style={styles.container}>
        <h1>
          <i className="fa fa-link" /> {t('equipsnSync.title')}
          &nbsp;
          <Button bsStyle="warning" bsSize="sm" onClick={this.handleResync} disabled={resyncLoading}>
            <i className={resyncLoading ? 'fa fa-refresh fa-spin' : 'fa fa-refresh'} /> {t('equipsnSync.resync')}
          </Button>
          &nbsp;
          <Button bsStyle="default" bsSize="sm" onClick={() => this._reload()}>
            <i className={loading ? 'fa fa-refresh fa-spin' : 'fa fa-refresh'} /> {t('equipsnSync.reload')}
          </Button>
          &nbsp;
          <Button bsStyle="default" bsSize="sm" onClick={this.handleExportCsv} disabled={exportLoading}>
            <i className={exportLoading ? 'fa fa-refresh fa-spin' : 'fa fa-download'} /> {t('equipsnSync.export_csv')}
          </Button>
        </h1>
        <Helmet title="EquipsnSync" />
        <p className="text-muted">{t('equipsnSync.description')}</p>
        <p className="alert alert-info">{t('equipsnSync.testlift_validation_help')}</p>
        <Button bsSize="sm" onClick={() => this.setState({ showAuthorizations: !this.state.showAuthorizations }, () => {
          if (this.state.showAuthorizations) this.loadAuthorizations(1);
        })}>{t('equipsnSync.testlift_authorizations')}</Button>
        &nbsp;
        <Button bsSize="sm" onClick={() => this.setState({ showClientKeys: !this.state.showClientKeys }, () => {
          if (this.state.showClientKeys) this.loadClientKeys();
        })}>{t('equipsnSync.client_keys_title')}</Button>
        {this.props.authorizationError && <div className="alert alert-danger" role="alert">{this.props.authorizationError.message || t('main.connection_error')}</div>}
        {this.state.lastScopeSync && (
          this.state.lastScopeSync.skipped
            ? <div className="alert alert-info">{t('equipsnSync.scope_sync_skipped')}</div>
            : this.state.lastScopeSync.success
              ? <div className="alert alert-success">{t('equipsnSync.scope_sync_success', this.state.lastScopeSync)}</div>
              : <div className="alert alert-danger">{t('equipsnSync.scope_sync_failed')}: {this.state.lastScopeSync.message}</div>
        )}
        {this.state.showAuthorizations && this.renderAuthorizations()}
        {this.state.showClientKeys && this.renderClientKeys()}

        {resyncError &&
          <div className="alert alert-danger">{t('equipsnSync.resync_error')}: {JSON.stringify(resyncError)}</div>}

        {resyncResult &&
          <div className="alert alert-success">
            <strong>{t('equipsnSync.resync_done')} (exit={resyncResult.exitCode})</strong>
            {resyncResult.stdout && <pre style={{ maxHeight: '200px', overflow: 'auto', fontSize: '11px' }}>{resyncResult.stdout}</pre>}
          </div>}

        {error &&
          <div className="alert alert-danger">{t('main.connection_error')}: {JSON.stringify(error)}</div>}

        {cleanOrphansResult &&
          <div className="alert alert-success">{t('equipsnSync.orphans_cleaned', { count: cleanOrphansResult.deleted })}</div>}

        {/* Alerte comptes à faible taux de résolution */}
        {stats && stats.low_resolution_accounts && stats.low_resolution_accounts.length > 0 && (
          <div className="alert alert-warning">
            <i className="fa fa-exclamation-triangle" />{' '}
            <strong>{t('equipsnSync.low_resolution_alert')}</strong>{' '}
            {stats.low_resolution_accounts.map((a) => (
              <span key={a.account} style={{ marginRight: '10px' }}>
                <a href="#" onClick={(e) => { e.preventDefault(); this.setState({ filterAccount: a.account, page: 1 }, () => this.props.load(this._buildParams())); }}>
                  {a.account}
                </a> ({a.resolution_rate}%)
              </span>
            ))}
          </div>
        )}

        {/* Alerte orphelins */}
        {stats && stats.orphan_count > 0 && (
          <div className="alert alert-info">
            <i className="fa fa-info-circle" />{' '}
            {t('equipsnSync.orphans_found', { count: stats.orphan_count })}
            {' '}
            <Button bsStyle="link" bsSize="xsmall" onClick={() => this.setState({ filterResolved: 'orphan', page: 1 }, () => this.props.load(this._buildParams()))}>
              {t('equipsnSync.view_orphans')}
            </Button>
            {' '}
            <Button bsStyle="link" bsSize="xsmall" onClick={this.handleCleanAllOrphans} disabled={cleanOrphansLoading}>
              {t('equipsnSync.clean_all_orphans')}
            </Button>
          </div>
        )}

        {/* Stats globales */}
        {stats && (
          <div style={styles.statsRow}>
            <div style={styles.statCard}>
              <div style={styles.statValue}>{stats.total || 0}</div>
              <div style={styles.statLabel}>{t('equipsnSync.stat_total')}</div>
            </div>
            <div style={styles.statCard}>
              <div style={styles.statValue}>{stats.in_clickhouse || 0}</div>
              <div style={styles.statLabel}>{t('equipsnSync.stat_resolved')}</div>
            </div>
            <div style={styles.statCard}>
              <div style={styles.statValue}>{stats.with_notify || 0}</div>
              <div style={styles.statLabel}>{t('equipsnSync.stat_with_notify')}</div>
            </div>
            <div style={styles.statCard}>
              <div style={styles.statValue}>{stats.recent_notify || 0}</div>
              <div style={styles.statLabel}>{t('equipsnSync.stat_recent_24h')}</div>
            </div>
            <div style={styles.statCard}>
              <div style={styles.statValue}>{stats.manual_count || 0}</div>
              <div style={styles.statLabel}>{t('equipsnSync.stat_manual')}</div>
            </div>
          </div>
        )}

        {/* Filtres */}
        <div style={styles.filtersRow}>
          <form onSubmit={this.handleSearchSubmit} style={{ flex: '1 1 300px' }}>
            <InputGroup>
              <FormControl
                type="text"
                placeholder={t('equipsnSync.search_placeholder')}
                value={search}
                onChange={this.handleSearchChange}
              />
              <InputGroup.Button>
                <Button type="submit" bsStyle="primary"><i className="fa fa-search" /></Button>
              </InputGroup.Button>
            </InputGroup>
          </form>

          <select className="form-control" style={{ width: '180px' }} value={filterAccount} onChange={this.handleFilterAccount}>
            <option value="all">{t('equipsnSync.all_accounts')}</option>
            {accountOptions.map(a => <option key={a} value={a}>{a}</option>)}
          </select>

          <DropdownButton id="filterResolved" title={t('equipsnSync.filter_' + filterResolved)} bsSize="sm">
            <MenuItem eventKey="all" onSelect={this.handleFilterResolved}>{t('equipsnSync.filter_all')}</MenuItem>
            <MenuItem eventKey="resolved" onSelect={this.handleFilterResolved}>{t('equipsnSync.filter_resolved')}</MenuItem>
            <MenuItem eventKey="unresolved" onSelect={this.handleFilterResolved}>{t('equipsnSync.filter_unresolved')}</MenuItem>
            <MenuItem eventKey="recent" onSelect={this.handleFilterResolved}>{t('equipsnSync.filter_recent')}</MenuItem>
            <MenuItem eventKey="manual" onSelect={this.handleFilterResolved}>{t('equipsnSync.filter_manual')}</MenuItem>
            <MenuItem eventKey="orphan" onSelect={this.handleFilterResolved}>{t('equipsnSync.filter_orphan')}</MenuItem>
          </DropdownButton>
        </div>

        {/* Table */}
        <div style={{ overflowX: 'auto' }}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>{t('equipsnSync.col_account')}</th>
                <th style={styles.th}>{t('equipsnSync.col_serial')}</th>
                <th style={styles.th}>{t('equipsnSync.col_equipsn')}</th>
                <th style={styles.th}>{t('equipsnSync.col_db_source')}</th>
                <th style={styles.th}>{t('equipsnSync.col_product_id')}</th>
                <th style={styles.th}>{t('equipsnSync.col_django_id')}</th>
                <th style={styles.th}>{t('equipsnSync.col_object_id')}</th>
                <th style={styles.th}>{t('equipsnSync.col_object_id_manual')}</th>
                <th style={styles.th}>{t('equipsnSync.col_resolved')}</th>
                <th style={styles.th}>{t('equipsnSync.col_last_notify')}</th>
                <th style={styles.th}>{t('equipsnSync.col_status')}</th>
                <th style={styles.th}>TestLift</th>
                <th style={styles.th}>{t('equipsnSync.col_actions')}</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr><td colSpan="13" style={{ textAlign: 'center', padding: '20px' }}>
                  <i className="fa fa-refresh fa-spin" /> {t('equipsnSync.loading')}
                </td></tr>
              )}
              {!loading && data && data.length === 0 && (
                <tr><td colSpan="13" style={{ textAlign: 'center', padding: '20px' }}>
                  {t('equipsnSync.no_data')}
                </td></tr>
              )}
              {!loading && data && data.map((row) => {
                var isRecent = row.last_notify && (new Date() - new Date(row.last_notify)) / (1000 * 60 * 60) <= 24;
                var statusBadge;
                if (row.is_manual) {
                  statusBadge = <span style={Object.assign({}, styles.badge, styles.badgeBlue)}>{t('equipsnSync.badge_manual')}</span>;
                } else if (isRecent) {
                  statusBadge = <span style={Object.assign({}, styles.badge, styles.badgeGreen)}>{t('equipsnSync.badge_recent')}</span>;
                } else if (row.in_clickhouse) {
                  statusBadge = <span style={Object.assign({}, styles.badge, styles.badgeOrange)}>{t('equipsnSync.badge_resolved')}</span>;
                } else {
                  statusBadge = <span style={Object.assign({}, styles.badge, styles.badgeRed)}>{t('equipsnSync.badge_unresolved')}</span>;
                }
                if (row.is_orphan) {
                  statusBadge = <span style={Object.assign({}, styles.badge, styles.badgeGray)}>{t('equipsnSync.badge_orphan')}</span>;
                }

                return (
                  <tr key={row.id}>
                    <td style={styles.td}><strong>{row.account}</strong></td>
                    <td style={styles.td}>{row.serial}</td>
                    <td style={styles.td}>{row.equipsn}</td>
                    <td style={styles.td}>{row.db_source}</td>
                    <td style={styles.td}>{row.product_id}</td>
                    <td style={styles.td}>{row.can_product_django_id || <span style={{ color: '#999' }}>—</span>}</td>
                    <td style={styles.td}>{row.object_id || <span style={{ color: '#999' }}>—</span>}</td>
                    <td style={styles.td}>
                      {editingId === row.id ? (
                        <InputGroup style={styles.manualInput}>
                          <FormControl
                            type="text"
                            value={editingValue}
                            onChange={this.handleEditChange}
                            placeholder="61PT00571A-100023"
                            disabled={updateLoading}
                          />
                          <InputGroup.Button>
                            <Button bsStyle="success" bsSize="xs" onClick={() => this.handleEditSave(row.id)} disabled={updateLoading}>
                              <i className="fa fa-check" />
                            </Button>
                            <Button bsStyle="default" bsSize="xs" onClick={this.handleEditCancel} disabled={updateLoading}>
                              <i className="fa fa-times" />
                            </Button>
                          </InputGroup.Button>
                        </InputGroup>
                      ) : (
                        <span>
                          {row.object_id_manual ? (
                            <strong style={{ color: '#337ab7' }}>{row.object_id_manual}</strong>
                          ) : <span style={{ color: '#999' }}>—</span>}
                          {' '}
                          {row.manual_updated_at && <small style={{ color: '#999' }}>({row.manual_updated_at})</small>}
                        </span>
                      )}
                    </td>
                    <td style={styles.td}>
                      <strong>{row.resolved_object_id || <span style={{ color: '#999' }}>—</span>}</strong>
                    </td>
                    <td style={styles.td}>{row.last_notify || <span style={{ color: '#999' }}>—</span>}</td>
                    <td style={styles.td}>{statusBadge}</td>
                    <td style={styles.td}>
                      <div>{t('equipsnSync.testlift_' + (!row.testlift_authorization_id ? 'pending' :
                        Number(row.testlift_active) !== 1 ? 'revoked' :
                        row.testlift_equipsn !== row.resolved_object_id || row.testlift_serial !== row.serial || row.is_orphan ? 'changed' : 'validated'))}</div>
                      {row.testlift_authorization_id && <small>{row.testlift_equipsn}<br />{row.testlift_validated_by} — {row.testlift_validated_at}</small>}
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                        {!row.is_orphan && row.client_id && row.resolved_object_id && (
                          <Button bsStyle="success" bsSize="xs" disabled={this.props.authorizationLoading || updateLoading || loading}
                            onClick={() => this.handleValidateTestLift(row)}>{t('equipsnSync.validate_testlift')}</Button>
                        )}
                        {Number(row.testlift_active) === 1 && <Button bsStyle="danger" bsSize="xs" disabled={this.props.authorizationLoading}
                          onClick={() => this.handleRevokeTestLift({ id: row.testlift_authorization_id, version: row.testlift_version, account: row.account, equipsn: row.testlift_equipsn })}>{t('equipsnSync.revoke_testlift')}</Button>}
                      </div>
                    </td>
                    <td style={styles.td}>
                      {editingId !== row.id && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                          {row.is_orphan ? (
                            <Button bsStyle="danger" bsSize="xs" onClick={() => this.handleCleanOrphan(row)} disabled={cleanOrphansLoading}>
                              <i className="fa fa-trash" /> {t('equipsnSync.delete_orphan')}
                            </Button>
                          ) : (
                            <>
                              <Button bsStyle="primary" bsSize="xs" onClick={() => this.handleEditStart(row.id, row.object_id_manual)}>
                                <i className="fa fa-pencil" /> {t('equipsnSync.edit_manual')}
                              </Button>
                              <Button bsStyle="info" bsSize="xs" onClick={() => this.handleResolveOpen(row)}>
                                <i className="fa fa-search" /> {t('equipsnSync.resolve')}
                              </Button>
                              <Button bsStyle="default" bsSize="xs" onClick={() => this.handleResyncOne(row)} disabled={resyncOneLoading} title={t('equipsnSync.resync_one')}>
                                <i className={resyncOneLoading ? 'fa fa-refresh fa-spin' : 'fa fa-refresh'} />
                              </Button>
                              <Button bsStyle="default" bsSize="xs" onClick={() => this.handleHistoryOpen(row)} title={t('equipsnSync.view_history')}>
                                <i className="fa fa-history" />
                              </Button>
                              {row.product_id && row.account && (
                                <LinkContainer to={'/admin/' + row.account + '/product/' + row.product_id + '/edit'}>
                                  <Button bsStyle="default" bsSize="xs" title={t('equipsnSync.open_product')}>
                                    <i className="fa fa-external-link" />
                                  </Button>
                                </LinkContainer>
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div style={styles.pagination}>
            <Button bsSize="sm" disabled={page === 1} onClick={() => this.handlePageChange(page - 1)}>
              <i className="fa fa-chevron-left" /> {t('pagination.previous')}
            </Button>
            <span>{page} / {totalPages} ({total})</span>
            <Button bsSize="sm" disabled={page >= totalPages} onClick={() => this.handlePageChange(page + 1)}>
              {t('pagination.next')} <i className="fa fa-chevron-right" />
            </Button>
          </div>
        )}

        {/* Modal de résolution assistée (overlay custom, évite le bug focus de react-bootstrap 0.30) */}
        {this.state.resolveModal.open && (
          <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.5)', zIndex: 9999,
            display: 'flex', justifyContent: 'center', alignItems: 'flex-start',
            padding: '40px 20px', overflowY: 'auto'
          }} onClick={this.handleResolveClose}>
            <div style={{
              background: '#fff', borderRadius: '6px', boxShadow: '0 5px 15px rgba(0,0,0,0.5)',
              maxWidth: '900px', width: '100%', maxHeight: '90vh', overflowY: 'auto'
            }} onClick={(e) => e.stopPropagation()}>
              <div style={{ padding: '15px 20px', borderBottom: '1px solid #e5e5e5', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h4 style={{ margin: 0 }}>
                  <i className="fa fa-search" /> {t('equipsnSync.resolve_title')}
                  {this.state.resolveModal.row && (
                    <span style={{ fontWeight: 'normal', fontSize: '14px', marginLeft: '10px' }}>
                      {this.state.resolveModal.row.account} / {this.state.resolveModal.row.serial}
                    </span>
                  )}
                </h4>
                <button type="button" className="close" onClick={this.handleResolveClose} style={{ fontSize: '21px', lineHeight: 1, color: '#000', opacity: 0.5, background: 'none', border: 'none', cursor: 'pointer' }}>&times;</button>
              </div>
              <div style={{ padding: '20px' }}>
                {this.props.resolveLoading && (
                  <div style={{ textAlign: 'center', padding: '40px' }}>
                    <i className="fa fa-refresh fa-spin" style={{ fontSize: '24px' }} />
                    <p>{t('equipsnSync.resolve_loading')}</p>
                  </div>
                )}

                {this.props.resolveError && (
                  <div className="alert alert-danger">
                    {t('equipsnSync.resolve_error')}: {JSON.stringify(this.props.resolveError)}
                  </div>
                )}

                {!this.props.resolveLoading && this.props.resolveResult && (
                  <div>
                    <p className="text-muted" style={{ fontSize: '12px' }}>
                      {t('equipsnSync.resolve_help')}
                    </p>

                    {this.props.resolveResult.candidates.length === 0 && (
                      <div className="alert alert-warning">
                        {t('equipsnSync.resolve_no_candidates')}
                      </div>
                    )}

                    {this.props.resolveResult.candidates.map((cand, idx) => {
                      var cardStyle = Object.assign({}, styles.candidateCard);
                      if (cand.matches_account) {
                        cardStyle = Object.assign({}, styles.candidateCard, styles.candidateCardMatch);
                      }

                      return (
                        <div key={idx} style={cardStyle}>
                          <div style={styles.candidateHeader}>
                            <div>
                              <span style={styles.candidateObjectId}>{cand.object_id}</span>
                              {' '}
                              {cand.matches_account && (
                                <span style={Object.assign({}, styles.badge, styles.badgeGreen)}>
                                  {t('equipsnSync.resolve_matches_account')}
                                </span>
                              )}
                            </div>
                            <div>
                              <Button
                                bsStyle="success"
                                bsSize="xs"
                                onClick={() => this.handleResolvePick(cand.object_id)}
                                disabled={this.props.updateLoading}
                              >
                                <i className="fa fa-check" /> {t('equipsnSync.resolve_pick')}
                              </Button>
                            </div>
                          </div>

                          <div style={styles.candidateMeta}>
                            <strong>token_sts:</strong> {cand.token_sts || '—'} |
                            <strong> last_notify:</strong> {cand.last_notify || '—'} |
                            <strong> events:</strong> {cand.event_count} |
                            <strong> code 83:</strong> {cand.code_83_count} |
                            <strong> code 85:</strong> {cand.code_85_count} |
                            <strong> code 86:</strong> {cand.code_86_count} |
                            <strong> identity:</strong> {cand.identity || '—'}
                          </div>

                          {cand.last_events && cand.last_events.length > 0 && (
                            <div style={{ marginTop: '8px' }}>
                              <strong style={{ fontSize: '11px' }}>{t('equipsnSync.resolve_last_events')}:</strong>
                              <div style={{ marginTop: '4px', background: '#fff', padding: '6px', borderRadius: '3px', border: '1px solid #eee' }}>
                                {cand.last_events.map((ev, evIdx) => (
                                  <div key={evIdx} style={styles.eventRow}>
                                    <span style={{ color: '#999' }}>{ev.date}</span>
                                    {' '}
                                    <strong>code={ev.code}</strong>
                                    {' '}
                                    <span style={{ color: '#337ab7' }}>{ev.token_sts}</span>
                                    {' '}
                                    {ev.identity && <span style={{ color: '#666' }}>identity={ev.identity}</span>}
                                    {' '}
                                    {ev.event && <span style={{ color: '#999' }}>{ev.event}</span>}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              <div style={{ padding: '15px 20px', borderTop: '1px solid #e5e5e5', textAlign: 'right' }}>
                <Button onClick={this.handleResolveClose}>{t('equipsnSync.resolve_close')}</Button>
              </div>
            </div>
          </div>
        )}

        {/* Modal historique des forçages manuels */}
        {this.state.historyModal.open && (
          <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.5)', zIndex: 9999,
            display: 'flex', justifyContent: 'center', alignItems: 'flex-start',
            padding: '40px 20px', overflowY: 'auto'
          }} onClick={this.handleHistoryClose}>
            <div style={{
              background: '#fff', borderRadius: '6px', boxShadow: '0 5px 15px rgba(0,0,0,0.5)',
              maxWidth: '700px', width: '100%', maxHeight: '90vh', overflowY: 'auto'
            }} onClick={(e) => e.stopPropagation()}>
              <div style={{ padding: '15px 20px', borderBottom: '1px solid #e5e5e5', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h4 style={{ margin: 0 }}>
                  <i className="fa fa-history" /> {t('equipsnSync.history_title')}
                  {this.state.historyModal.row && (
                    <span style={{ fontWeight: 'normal', fontSize: '14px', marginLeft: '10px' }}>
                      {this.state.historyModal.row.account} / {this.state.historyModal.row.serial}
                    </span>
                  )}
                </h4>
                <button type="button" className="close" onClick={this.handleHistoryClose} style={{ fontSize: '21px', lineHeight: 1, color: '#000', opacity: 0.5, background: 'none', border: 'none', cursor: 'pointer' }}>&times;</button>
              </div>
              <div style={{ padding: '20px' }}>
                {this.props.historyLoading && (
                  <div style={{ textAlign: 'center', padding: '40px' }}>
                    <i className="fa fa-refresh fa-spin" style={{ fontSize: '24px' }} />
                  </div>
                )}

                {this.props.historyError && (
                  <div className="alert alert-danger">
                    {JSON.stringify(this.props.historyError)}
                  </div>
                )}

                {!this.props.historyLoading && this.props.historyRows && this.props.historyRows.length === 0 && (
                  <div className="alert alert-info">{t('equipsnSync.history_empty')}</div>
                )}

                {!this.props.historyLoading && this.props.historyRows && this.props.historyRows.length > 0 && (
                  <table style={styles.table}>
                    <thead>
                      <tr>
                        <th style={styles.th}>{t('equipsnSync.history_date')}</th>
                        <th style={styles.th}>{t('equipsnSync.history_admin')}</th>
                        <th style={styles.th}>{t('equipsnSync.history_action')}</th>
                        <th style={styles.th}>{t('equipsnSync.history_old')}</th>
                        <th style={styles.th}>{t('equipsnSync.history_new')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.historyRows.map((h) => (
                        <tr key={h.id}>
                          <td style={styles.td}>{h.created_at}</td>
                          <td style={styles.td}><strong>{h.admin_username}</strong></td>
                          <td style={styles.td}>
                            {h.action === 'set'
                              ? <span style={Object.assign({}, styles.badge, styles.badgeBlue)}>{t('equipsnSync.history_action_set')}</span>
                              : <span style={Object.assign({}, styles.badge, styles.badgeGray)}>{t('equipsnSync.history_action_clear')}</span>}
                          </td>
                          <td style={styles.td}>{h.old_value || <span style={{ color: '#999' }}>—</span>}</td>
                          <td style={styles.td}>{h.new_value || <span style={{ color: '#999' }}>—</span>}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
              <div style={{ padding: '15px 20px', borderTop: '1px solid #e5e5e5', textAlign: 'right' }}>
                <Button onClick={this.handleHistoryClose}>{t('equipsnSync.resolve_close')}</Button>
              </div>
            </div>
          </div>
        )}

      </div>
    );
  }
}
